module.exports = __webpack_public_path__ + "img/video-05.e694a383.png";